// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// This is only for simple case to use
export const SimpleValidation = run => ({
	run,
	concat: other =>
		Validation(x => run(x).concat(other.run(x)))
});

export const Success = x => ({
	x,
	isFail: false,
	fold: (f, g) => g(x),
	concat: other => other.isFail ? other : Success(x)
});

export const Fail = x => ({
	x,
	isFail: true,
	fold: (f, g) => f(x),
	concat: other => other.isFail ? Fail(false) : Fail(x)
});

const validate = (validations, obj): boolean => 
	validations.foldMap(
		v => v.run(obj),
		Success(true)
	).x;

export const SimpleValidator = {
	validate
};